'use client';

import { usePathname } from 'next/navigation';
import { useState } from 'react';

import CommonBackButton from '@/components/common/commonBackBtn';

export default function ErrorTemplate({ title, sub }: { title: string; sub: string }) {
  const pathname = usePathname();
  const [clickCount, setClickCount] = useState(0);
  const isDev = process.env.isProdServer === 'false';

  const handleIconClick = () => {
    if (!isDev) return;
    setClickCount((prev) => {
      if (prev === 2) {
        console.log('Debug pathname:', pathname);
      }
      return prev < 3 ? prev + 1 : 0;
    });
  };

  return (
    <div className="etc_wrap">
      <i className="icon_error" onClick={handleIconClick}>
        <span className="text_blind">통신 중단 등 장애 아이콘</span>
        {clickCount === 3 && isDev && pathname}
      </i>
      <b className="title" dangerouslySetInnerHTML={{ __html: title }} />
      <p className="text" dangerouslySetInnerHTML={{ __html: sub }} />
      <CommonBackButton text="이전으로 돌아가기" />
    </div>
  );
}
